export type GygWidgetType = 'activities' | 'city';

export interface BuildGygWidgetPropsParams {
  partnerId: string;
  query: string;
  cmp: string;
  widgetType: GygWidgetType;
  localeCode?: string;
  numberOfItems?: number;
}

export interface GygWidgetDataAttributes {
  'data-gyg-widget': GygWidgetType;
  'data-gyg-partner-id': string;
  'data-gyg-q': string;
  'data-gyg-locale-code': string;
  'data-gyg-cmp': string;
  'data-gyg-number-of-items'?: string;
}

const DEFAULT_LOCALE = 'en-US';
const DEFAULT_NUMBER_OF_ITEMS = 3;

/**
 * Appends a widget discriminator to a base cmp string for multi-widget surfaces.
 */
export function appendGygWidgetCmpSuffix(cmp: string, widgetKey: string): string {
  const trimmed = cmp?.trim();
  const key = widgetKey?.trim();
  if (!trimmed || !key) {
    return trimmed;
  }
  return `${trimmed}:widget:${key}`;
}

/**
 * Maps widget config to GYG data-* attributes for embed containers.
 */
export function buildGygWidgetProps(params: BuildGygWidgetPropsParams): GygWidgetDataAttributes {
  const {
    partnerId,
    query,
    cmp,
    widgetType,
    localeCode = DEFAULT_LOCALE,
    numberOfItems = DEFAULT_NUMBER_OF_ITEMS,
  } = params;

  const attrs: GygWidgetDataAttributes = {
    'data-gyg-widget': widgetType,
    'data-gyg-partner-id': partnerId.trim(),
    'data-gyg-q': query.trim(),
    'data-gyg-locale-code': localeCode,
    'data-gyg-cmp': cmp.trim(),
  };

  if (widgetType === 'activities') {
    attrs['data-gyg-number-of-items'] = String(numberOfItems);
  }

  return attrs;
}
